import { t } from "ttag";

import { JourneySupportBanner } from "@/features/coaching/components";
import { Card, UserHeartRoundedIcon } from "@/shared/ui";

export const OneOnOneSupportSection = () => {
  return (
    <Card.Root ghost>
      <Card.Title icon={UserHeartRoundedIcon}>{t`1-on-1 support`}</Card.Title>

      <div className="flex flex-col gap-6 md:flex-row">
        <JourneySupportBanner />

        {/* <NutritionalCounselingBanner /> */}
      </div>
    </Card.Root>
  );
};
